/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.directives {

    export interface IConditionEditorScope extends ng.IScope {
        model: ConditionEditorModel;
        hidename: boolean;
        processConfiguration: Wars.Domain.Model.ProcessConfiguration;
        condition: Wars.Domain.Model.Conditions.Condition;
        getSelectedNode: (data: models.TreeConfigurationItem) => void;
    }

    export class ConditionEditor implements IDirective {
        public link($scope: IConditionEditorScope, element: JQuery, attrs: ng.IAttributes, controller: ConditionEditorController) {
            //var s = <any>$scope;
            //$scope.model = new ConditionEditorModel(s.hidename,s.processConfiguration);
        }
        public templateUrl = './app/views/directives/conditionEditor.html';
        public restrict: string = 'E';
        public controller = ['$scope', '$q', 'conditionService', 'tagService', "growl", "treeService", ConditionEditorController];
        public controllerAs = 'controller'; 
        public scope: any = {
            processConfiguration: "=",
            condition: "=",
            hidename: "="
        };
    }

    declare var _conditionEditorModelSelf: any;

    export class ConditionEditorModel {
        public tinyMceOptions: any;
        public treeData: any;
        public condition: Wars.Domain.Model.Conditions.Condition;
        public showAdvancedEditor: boolean;
        public processConfiguration: Wars.Domain.Model.ProcessConfiguration;
        public excludeItem: models.TreeConfigurationItem;
        public hidename: boolean = false;
        public isReversingJavascript = false;
        public tags: string[];
        public conditionTags: string[];
        public $q: ng.IQService;
        public currentTreeItem: models.TreeConfigurationItem;

        constructor(
            condition:Wars.Domain.Model.Conditions.Condition,
            hideName: boolean,
            processConfiguration: Wars.Domain.Model.ProcessConfiguration,
            private conditionService: services.ConditionService,
            private tagService: services.TagService,
            private growlService: angular.growl.IGrowlService,
            private treeService: services.TreeService,
            $q: ng.IQService)
        {
            this.condition = condition;
            _conditionEditorModelSelf = this;
            this.hidename = hideName;
            this.processConfiguration = processConfiguration;
            this.excludeItem = new models.TreeConfigurationItem();
            this.excludeItem.conditionId = this.condition.id;
            this.$q = $q;

            this.tinyMceOptions = {
                format: 'raw',
                menubar: false,
                height: 50,
                plugins: "noneditable, image",
                content_css: "content/mce.css",
                toolbar1:
                'insertfield | undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent',
                relative_urls: false,
                remove_script_host: false,
                document_base_url: localStorage.getItem('baseUrl'),
                setup: (editor) => {
                    editor.addButton('insertfield',
                        {
                            text: 'Insert Field',
                            icon: false,
                            onclick: () => {
                                if (!this.currentTreeItem) {
                                    this.growlService.error('A field must be selected on the tree before you can insert a field.');
                                } else {
                                    var treeItem = this.treeService.createTreeItemFromConfig(this.currentTreeItem,
                                        () => {
                                            treeItem.conditionBinding_id = this.condition.id;
                                            this.condition.bindings.push(treeItem);
                                            editor.insertContent("<span class='mceNonEditable fieldBind' data-TreeId=" + treeItem.id + ">" + this.currentTreeItem.text + "</span>");
                                        });
                                }
                            }
                        });
                }
            };
        }

        public showAdvanced() {
            this.showAdvancedEditor = true;
        }

        public showBasic() {
            this.showAdvancedEditor = false;    
        }

        public resetCondition() {
            //this.condition.expressionParts = [];
            this.condition.javascript = '';
            //this.condition.setConditionDependencies(this.conditionService);
        }

        public aceLoaded(editor:AceAjax.Editor) {
            var langTools = ace.require("ace/ext/language_tools");
            
            var processCompleter = {
                getCompletions: function (editor, session, pos, prefix, callback) {
                    if (prefix.startsWith("a")) {
                        callback(null, [{ name: 'process', value: 'process', score: 300, meta: "App" }]);
                    }
                    else {
                        callback(null, []);
                    }
                }
            }

            var processCompleter2 = {
                getCompletions: function (editor, session, pos, prefix, callback) {
                    if (session.getLine(pos.row).substr(pos.column - 12 + prefix.length, 12) == "process.") {
                        var uniqueNames = Wars.Domain.Model.ProcessConfigurationUtilities.GetFieldUniqueNames(_conditionEditorModelSelf.processConfiguration);

                        if (prefix.length === 0) {
                            let result = uniqueNames.select(s => {return {
                                    name: s,
                                    value:s,
                                    score:300,
                                    meta:"fields"
                                }
                            });

                            callback(null, result.toArray());
                        } else {
                            let result = uniqueNames.where(s=>s.indexOf(pos) === 0).select(s => {
                                return {
                                    name: s,
                                    value: s,
                                    score: 300,
                                    meta: "fields"
                                }
                            });

                            callback(null, result.toArray());
                        }
                    } else {
                        callback(null, []);
                    }
                }
            }
            
            langTools.addCompleter(processCompleter);
            langTools.addCompleter(processCompleter2);
        }

        public addTag(tag) {
            var newTag = this.tagService.createTag();
            newTag.tagName = tag.text;
            newTag.tagType = Wars.Domain.Model.Codes.Enums.TagType.Condition;
            newTag.condition_id = this.condition.id;
            newTag.calculation_id = null;
            newTag.queryConfiguration_id = null;
            newTag.myCondition = this.condition;

            this.condition.tags.push(newTag);
        }

        public removeTag(tag) {
            this.condition.tags.forEach(t => {
                if (t.tagName === tag.text) {
                    t.entityAspect.setDeleted();
                }
            });
        }

        public searchTags(query: string) {
            var queryLength = query.length;
            var deferred = this.$q.defer();
            var returnTags = Enumerable.from(this.conditionTags)
                .where(i => i.substring(0, queryLength) === query)
                .toArray();
            deferred.resolve(returnTags);
            return deferred.promise;
        }
    }

    export class ConditionEditorController implements IController {
        private scope: IConditionEditorScope;
        private $q: ng.IQService;

        constructor(
            private $scope: IConditionEditorScope,
            $q: ng.IQService,
            conditionService: services.ConditionService,
            tagService: services.TagService,
            growlService: angular.growl.IGrowlService,
            treeService: services.TreeService)
        {
            $scope.model = new ConditionEditorModel(
                $scope.condition,
                $scope.hidename,
                $scope.processConfiguration,
                conditionService,
                tagService,
                growlService,
                treeService,
                $q);
            $scope.model.condition.entityAspect.loadNavigationProperty("expression");

            $scope.model.conditionTags = [];
            tagService.getTagsLike(Wars.Domain.Model.Codes.Enums.TagType.Condition)
                .then(result => {
                    $scope.model.conditionTags = Enumerable.from(result).select(i => i.tagName).distinct().toArray();
                });

            $scope.$watch("condition", (newValue) => {
                $scope.model.condition = <models.Condition>newValue;
                $scope.model.tags = [];
                $scope.model.condition.tags.forEach(t => {
                    $scope.model.tags.push(t.tagName);
                });
            });

            $scope.getSelectedNode = (data: models.TreeConfigurationItem) => this.getSelectedNode(data);
        }

        private getSelectedNode(data: models.TreeConfigurationItem): void {
            this.$scope.model.currentTreeItem = data;
        }
    }
}

warsApp.registerDirective('ConditionEditor', []);